import { useEffect, useState } from "react";
import { meta, pingProvider } from "../lib/api";
import type { AppConfig } from "../types";

interface Props {
  config: AppConfig;
  setConfig: (c: AppConfig) => void;
}

export function Settings({ config, setConfig }: Props) {
  const [pingMsg, setPingMsg] = useState<string>("");
  const [info, setInfo] = useState<any>(null);

  async function testar() {
    setPingMsg("testando…");
    const r = await pingProvider(config);
    setPingMsg(r.ok ? `✓ conectado (${r.detail})` : `✗ ${r.detail}`);
  }

  useEffect(() => {
    meta(config).then(setInfo).catch(() => setInfo(null));
  }, [config.apiUrl]);

  return (
    <div className="settings">
      <section>
        <h2>Backend SupriAI</h2>
        <label>API URL
          <input value={config.apiUrl} onChange={(e) => setConfig({ ...config, apiUrl: e.target.value })} />
        </label>
        <label>Token (preenchido após login)
          <input type="password" value={config.apiKey} readOnly />
        </label>
        <button onClick={testar}>Testar conexão</button>
        {pingMsg && <div className="muted">{pingMsg}</div>}
      </section>

      <section>
        <h2>Modelo padrão</h2>
        <p className="muted">
          Inferência 100% local na VPS via Qwen + llama.cpp (Ollama). Sem custo, sem rate limit,
          sem dependência externa.
        </p>
        <label>Modelo (deixe em branco para usar o default por agente)
          <input
            value={config.qwenModel}
            placeholder="qwen3-coder:30b | qwen2.5-coder:32b | qwen3:14b | qwen2.5:14b"
            onChange={(e) => setConfig({ ...config, qwenModel: e.target.value })}
          />
        </label>
        <p className="muted">
          Defaults atuais — chat: <code>{info?.qwen_chat_model || "—"}</code> · code:{" "}
          <code>{info?.qwen_code_model || "—"}</code> · agente:{" "}
          <code>{info?.qwen_agent_model || "—"}</code>
        </p>
      </section>

      {info && (
        <section>
          <h2>Capacidades atuais</h2>
          <p className="muted">Tools disponíveis no backend:</p>
          <div className="tools-grid">
            {(info.tools || []).map((t: string) => (
              <span key={t} className="tool-chip"><code>{t}</code></span>
            ))}
          </div>
          <p className="muted">Agentes:</p>
          <div className="tools-grid">
            {(info.agents || []).map((a: string) => (
              <span key={a} className="tool-chip"><code>{a}</code></span>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
